/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { CreateClusterActions, CreateClusterActionTypes, CreateClusterParams } from './types';

export const openCreateClusterOverlay = ({
  serviceType,
  projectId,
  organizationId,
  fromBackup,
  clusterId,
}: CreateClusterParams): CreateClusterActionTypes => ({
  type: CreateClusterActions.OPEN_CREATE_CLUSTER_OVERLAY,
  payload: {
    serviceType,
    projectId,
    organizationId,
    fromBackup,
    clusterId,
  },
});

export const closeCreateClusterOverlay = (): CreateClusterActionTypes => ({
  type: CreateClusterActions.CLOSE_CREATE_CLUSTER_OVERLAY,
});
